import React from 'react';
import { useTranslation } from 'react-i18next';
import { CloseProductSection } from '../../components/CloseProductSection';
import { useCloseConfigureModal } from '../../hooks/useCloseConfigureModal';
import { useDeactivateExternallyServicedProduct } from '../../hooks/useDeactivateExternallyServicedProduct';
import { useGenericCloseBodyText } from '../../hooks/useGenericCloseBodyText';
import { ConfigureProductDialog } from '../../shell/ConfigureProductDialog';
import type { ConfigureProductGroupModalProps } from '../configureProductGroupModalProps';

const MODAL_WIDTH = '540px';

export const ActiveReferralRmModal: React.FC<ConfigureProductGroupModalProps> = ({ serviceAgreement, brUid }) => {
  const { t } = useTranslation();
  const { close, isClosing } = useDeactivateExternallyServicedProduct(serviceAgreement, brUid);
  const closeBodyText = useGenericCloseBodyText();
  const handleClose = useCloseConfigureModal(false);

  return (
    <ConfigureProductDialog
      title={t('pb.configureproductmodal.activeReferralRm.title')}
      width={MODAL_WIDTH}
      size="small"
      isPending={false}
      onClose={handleClose}
      footer={{
        canSave: false,
        saveBlockedReasons: [],
        showSave: false,
        closeLabel: t('pb.configureproductmodal.wealthplanning.close'),
      }}
    >
      <CloseProductSection
        isPending={false}
        bodyText={closeBodyText}
        addTopMargin={false}
        isClosing={isClosing}
        onConfirmClose={close}
      />
    </ConfigureProductDialog>
  );
};
